import { render, staticRenderFns } from "./BannedIpEdit.vue?vue&type=template&id=3a05b21a"
import script from "./BannedIpEdit.vue?vue&type=script&lang=js"
export * from "./BannedIpEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports